import ValidationRegex from '../data/Utils.Data.ValidationRegex';

export default function getOfficeLivePreviewUrl(url: string) {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${
    ValidationRegex.absolutePath.test(url) ? document.location.origin : ''
  }${url}`;
}
